import { render, staticRenderFns } from "./StikerObat.vue?vue&type=template&id=6d9c0061&"
import script from "./StikerObat.vue?vue&type=script&lang=js&"
export * from "./StikerObat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports